/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize AlbuminuriaProgress View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AlbuminuriaProgressView';

export const mapStateToPropsAlbuminuriaProgress = mapStateToProps;
export const mapDispatchToPropsAlbuminuriaProgress = mapDispatchToProps;

export default connect(
  mapStateToPropsAlbuminuriaProgress,
  mapDispatchToPropsAlbuminuriaProgress
)(View);
